import type { ProductDirectoryEntry, ProductDirectoryResponse } from './product-directory-api';

/*
 * The legend is the reading order, so the list follows it: Audience, then Money, and so on, and
 * inside a category the weight the server gave each product. The panel and the dashboard widget
 * draw the same catalog, so they read it in the same order from here.
 */
function arrangeProducts(directory: ProductDirectoryResponse | null): ProductDirectoryEntry[] {
  if (directory === null) {
    return [];
  }
  const order = new Map<string, number>();
  directory.categories.forEach((category, index) => {
    order.set(category.key, index);
  });
  const last = directory.categories.length;
  function rank(product: ProductDirectoryEntry): number {
    const index = order.get(product.category);
    if (index === undefined) {
      return last;
    }
    return index;
  }
  return [...directory.products].sort((left, right) => {
    if (rank(left) !== rank(right)) {
      return rank(left) - rank(right);
    }
    return left.weight - right.weight;
  });
}

/** The product you are in, which is what badges its own actions. */
function getOpenProduct(products: ProductDirectoryEntry[], current: string): ProductDirectoryEntry | undefined {
  return products.find((product) => product.name === current);
}

export { arrangeProducts, getOpenProduct };
